export const H7_CATEGORY_ID = 19

export const buildH7CategoryRoute = category => {
  const parent = category?.nested_parents_light
  const grandParent = parent?.nested_parents_light

  if (!category?.slug || !parent?.slug || !grandParent?.slug) {
    return null
  }

  return {
    name: 'categories-domain-category-subcategory',
    params: {
      domain: grandParent.slug,
      category: parent.slug,
      subcategory: category.slug,
    },
  }
}

export const isH7CategoryRestricted = (category, locale) =>
  Array.isArray(category?.restricted_locales) &&
  category.restricted_locales.includes(locale)
